type IBusinessInfo = {
  label: string;
  value: string;
};

export const brandType: IBusinessInfo[] = [
  { label: "Sole Proprietorship", value: "Sole Proprietorship" },
  { label: "Standard", value: "Standard" },
  { label: "Low-Volume Standard", value: "Low-Volume Standard" },
];

export const businessType: IBusinessInfo[] = [
  { label: "Co-operative", value: "Co-operative" },
  { label: "Corporation", value: "Corporation" },
  { label: "Limited Liability Corporation", value: "Limited Liability" },
  { label: "Non-profit Corporation", value: "Non-profit Corporation" },
  { label: "Partnership", value: "Partnership" },
];

export const businessIndustry: IBusinessInfo[] = [
  { label: "Agriculture", value: "AGRICULTURE" },
  { label: "Automotive", value: "AUTOMOTIVE" },
  { label: "Banking", value: "BANKING" },
  { label: "Construction", value: "CONSTRUCTION" },
  { label: "Consumer", value: "CONSUMER" },
  { label: "Education", value: "EDUCATION" },
  { label: "Electronics", value: "ELECTRONICS" },
  { label: "Engineering", value: "ENGINEERING" },
  { label: "Energy", value: "ENERGY" },
  { label: "Fast Moving Consumer Goods", value: "FAST_MOVING_CONSUMER_GOODS" },
  { label: "Financial", value: "FINANCIAL" },
  { label: "Fintech", value: "FINTECH" },
  { label: "Food and Beverage", value: "FOOD_AND_BEVERAGE" },
  { label: "Government", value: "GOVERNMENT" },
  { label: "Healthcare", value: "HEALTHCARE" },
  { label: "Hospitality", value: "HOSPITALITY" },
  { label: "Insurance", value: "INSURANCE" },
  { label: "Jewelry", value: "JEWELRY" },
  { label: "Legal", value: "LEGAL" },
  { label: "Manufacturing", value: "MANUFACTURING" },
  { label: "Media", value: "MEDIA" },
  { label: "Not for profit", value: "NOT_FOR_PROFIT" },
  { label: "Oil and Gas", value: "OIL_AND_GAS" },
  { label: "Professional Services", value: "PROFESSIONAL_SERVICES" },
  { label: "Raw Materials", value: "RAW_MATERIALS" },
  { label: "Real Estate", value: "REAL_ESTATE" },
  { label: "Religion", value: "RELIGION" },
  { label: "Online", value: "ONLINE" },
  { label: "Retail", value: "RETAIL" },
  { label: "Technology", value: "TECHNOLOGY" },
  { label: "Telecommunications", value: "TELECOMMUNICATIONS" },
  { label: "Transportation", value: "TRANSPORTATION" },
  { label: "Travel", value: "TRAVEL" },
];

export const businessRegistrationIdentifier: IBusinessInfo[] = [
  { label: "EIN", value: "EIN" },
  { label: "DUNS", value: "DUNS" },
  { label: "CBN", value: "CBN" },
  { label: "CN", value: "CN" },
  { label: "ACN", value: "ACN" },
  { label: "CIN", value: "CIN" },
  { label: "VAT", value: "VAT" },
  { label: "VATRN", value: "VATRN" },
  { label: "RN", value: "RN" },
  { label: "Other", value: "Other" },
];

export const businessIdentity = [
  { label: "Direct Customer", value: "direct_customer" },
  { label: "ISV Reseller or Partner", value: "isv_reseller_or_partner" },
  { label: "Unknown", value: "unknown" },
];

export const businessRegion: IBusinessInfo[] = [
  { label: "Africa", value: "AFRICA" },
  { label: "Asia", value: "ASIA" },
  { label: "Europe", value: "EUROPE" },
  { label: "Latin America", value: "LATIN_AMERICA" },
  { label: "USA and Canada", value: "USA_AND_CANADA" },
];

export const jobPositions: IBusinessInfo[] = [
  { label: "Director", value: "Director" },
  { label: "GM", value: "GM" },
  { label: "VP", value: "VP" },
  { label: "CEO", value: "CEO" },
  { label: "CFO", value: "CFO" },
  { label: "General Counsel", value: "General Counsel" },
  { label: "Other", value: "Other" },
];

export const stockExchanges: IBusinessInfo[] = [
  { label: "AMEX", value: "AMEX" },
  { label: "AMX", value: "AMX" },
  { label: "ASX", value: "ASX" },
  { label: "B3", value: "B3" },
  { label: "BME", value: "BME" },
  { label: "BSE", value: "BSE" },
  { label: "FRA", value: "FRA" },
  { label: "ICEX", value: "ICEX" },
  { label: "JPX", value: "JPX" },
  { label: "JSE", value: "JSE" },
  { label: "KRX", value: "KRX" },
  { label: "LON", value: "LON" },
  { label: "NASDAQ", value: "NASDAQ" },
  { label: "NONE", value: "NONE" },
  { label: "NYSE", value: "NYSE" },
  { label: "NSE", value: "NSE" },
  { label: "OMX", value: "OMX" },
  { label: "OTHER", value: "OTHER" },
  { label: "SEHK", value: "SEHK" },
  { label: "SGX", value: "SGX" },
  { label: "SSE", value: "SSE" },
  { label: "STO", value: "STO" },
  { label: "SWX", value: "SWX" },
  { label: "SZSE", value: "SZSE" },
  { label: "TSX", value: "TSX" },
  { label: "TWSE", value: "TWSE" },
  { label: "VSE", value: "VSE" },
];

export const companyType: IBusinessInfo[] = [
  { label: "Government", value: "government" },
  { label: "Non profit", value: "non_profit" },
  { label: "Private", value: "private" },
  { label: "Public", value: "public" },
];

export const verticals: IBusinessInfo[] = [
  { label: "Agriculture", value: "AGRICULTURE" },
  { label: "Communication", value: "COMMUNICATION" },
  { label: "Energy", value: "ENERGY" },
  { label: "Entertainment", value: "ENTERTAINMENT" },
  { label: "Financial", value: "FINANCIAL" },
  { label: "Gambling", value: "GAMBLING" },
  { label: "Government", value: "GOVERNMENT" },
  { label: "Healthcare", value: "HEALTHCARE" },
  { label: "Hospitality", value: "HOSPITALITY" },
  { label: "Human resources", value: "HUMAN_RESOURCES" },
  { label: "Insurance", value: "INSURANCE" },
  { label: "Legal", value: "LEGAL" },
  { label: "Manufacturing", value: "MANUFACTURING" },
  { label: "NGO", value: "NGO" },
  { label: "Political", value: "POLITICAL" },
  { label: "Postal", value: "POSTAL" },
  { label: "Professional", value: "PROFESSIONAL" },
  { label: "Real estate", value: "REAL_ESTATE" },
  { label: "Retail", value: "RETAIL" },
  { label: "Technology", value: "TECHNOLOGY" },
  { label: "Transportation", value: "TRANSPORTATION" },
];

export const mapStages: IBusinessInfo[] = [
  {
    label: "Appointments",
    value: "Appointments",
  },
  {
    label: "Hot Prospect",
    value: "Hot Prospect",
  },
  {
    label: "Nurture",
    value: "Nurture",
  },
  {
    label: "Active Client",
    value: "Active Client",
  },
  {
    label: "Closed",
    value: "closed",
  },
];
